import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MainNav from '@/components/layout/AppNavbar';

function NotFound() {
    const { t } = useTranslation();

    return (
        <>
            <MainNav />
            <main className="container-lg nav-padding">
                <div className="text-center py-5">
                    <div className="mb-4">
                        <h1 className="display-1 fw-bold text-primary">

                        </h1>
                        <h2 className="mb-3">{t('page_not_found')}</h2>
                        <p className="text-muted mb-4">{t('page_not_found_description')}</p>
                    </div>

                    <div className="d-flex justify-content-center">
                        <Link to="/" className="btn btn-primaryF rounded-pill">
                            <FontAwesomeIcon icon={["fas", "home"]} className="me-2" />
                            {t('back_to_home')}
                        </Link>
                    </div>
                </div>
            </main>
        </>
    );
}

export default NotFound;